import InfantMeatsProduct from 'models/InfantMeatsProduct'

export const brandNameOptions = [
  {
    value: '',
    label: 'Brand Name',
    isDisabled: true,
  },
  { value: 'Beech-Nut', label: 'Beech-Nut' },
  { value: 'Gerber', label: 'Gerber' },
  { value: "Mom's Organic Choice", label: "Mom's Organic Choice" },
]

export const packagingInitialState = {
  category: InfantMeatsProduct.category,
  subCategory: InfantMeatsProduct.subCategory,
  PackageType: {
    value: '',
    label: 'Package Type',
  },
  PacketSize: '2.5 ounces only',
  MultiPackageType: false,
  MultiPackageCount: '',
  Organic: false,
  NoAdditionalIngredients: false,
}

export const packageTypeOptions = [
  {
    value: '',
    label: 'Package Type',
    isDisabled: true,
  },
  { value: 'Jar', label: 'Jar' },
  { value: 'Plastic', label: 'Plastic' },
]
